import "./ImageGallery.css"
import "./GalleryStyles.css"
const GalleryText = () => {
  return (
    <div className="gallery-container">
      <h1>Campus Highlights</h1>
      <p>
        Explore memorable moments from Jupiter Learning Academy. 
        Our gallery showcases academic activities, student achievements, 
        classroom experiences, laboratory sessions, and special events 
        that reflect our vibrant campus life.
      </p>
    </div>
  )
}

export default GalleryText;
